import { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Alert, Breadcrumb, Button, Card, Col, Divider, List, Modal, Row, Space, Typography } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { fetchUserCreatedCollections, fetchUserCreatedModules } from './actions/contentCreation';
import './Components.less';
import CollectionInfoCard from './Components/CollectionInfoCard';
import CollectionModulesList from './Components/CollectionModulesList';


const { Text, Title } = Typography;

class CreatorHome extends Component {

    constructor(props) {
        super(props);
        this.state = {
            collection: {
                name: "Collection Name",
                primaryAuthor: {
                    firstName: "AuthorFirstName",
                    lastName: "AuthorLastName"
                },
                coAuthors: [],
                modules: [
                    {
                        name: "1st Module Name",
                        primaryAuthor: {
                            firstName: "AuthorFirstName",
                            lastName: "AuthorLastName"
                        },
                        coAuthors: [],
                        videos: [ 
                            {
                                title: "Video Title",
                                embedId: "12345678",
                                videoType: "youtube"
                            },
                            {
                                title: "Video Title",
                                embedId: "12345678",
                                videoType: "youtube"
                            }
                        ]
                    },
                    {
                        name: "2nd Module Name",
                        primaryAuthor: {
                            firstName: "AuthorFirstName",
                            lastName: "AuthorLastName"
                        },
                        coAuthors: [],
                        videos: [
                            {
                                title: "Video Title",
                                embedId: "12345678",
                                videoType: "youtube"
                            },
                            {
                                title: "Video Title",
                                embedId: "12345678",
                                videoType: "youtube"
                            },
                            {
                                title: "Video Title",
                                embedId: "12345678",
                                videoType: "youtube"
                            },
                            {
                                title: "Video Title",
                                embedId: "12345678",
                                videoType: "youtube"
                            }
                        ]
                    }
                ]
            }
        }
    }
    componentDidMount(){
        if(this.props.user){
            this.props.fetchUserCreatedModules(this.props.user.id)
            this.props.fetchUserCreatedCollections(this.props.user.id)
        }
    }

    render() {
        return <div className="centered-container">
                    <Modal 
                        visible={false}
                        footer={null}
                        width={1000}
                    >
                        <div className="modal-body">
                            <Title level={4}>Welcome!</Title>
                            <CollectionInfoCard 
                                collection={this.state.collection}
                                collectionNetPrice={200}
                                key={"tutorial-collection"}
                                mode="preview"
                            />
                            <CollectionModulesList 
                                collection={this.state.collection} 
                                mode="preview"
                                urlParams={this.props.match.params}
                            />
                        </div>
                    </Modal>
                    <Space className="breadcrumbs">
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <Link to="/"><HomeOutlined /></Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>Creator Home</Breadcrumb.Item>
                        </Breadcrumb>
                    </Space>
                    <Card>
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={9} md={8} lg={8} xl={8}>
                                <Space direction="vertical">
                                    Ready to create a full course?
                                    <Button type="primary" onClick={()=>this.props.history.push('/collections/create')}>Create Collection</Button>
                                </Space>
                            </Col>
                            <Col xs={24} sm={15} md={12} lg={8} xl={8}>
                                <Space direction="vertical">
                                    Or do you want to assemble videos for a small topic?
                                    <Button onClick={()=>this.props.history.push('/modules/create')}>Create Module</Button>
                                </Space>
                            </Col>
                            <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                            </Col>
                        </Row>
                    </Card>
                    <br/>
                    <Alert
                        message="Please Note"
                        description="As of 2/21/2022, we have made some major redesign changes which resulted in some necessary changes to the URLs of all collections, modules, and videos. Please be sure to update your links (available for download by clicking 'Share' in your created collection page) so that students may continue to have access to your videos. We apologize for the inconvenience."
                        type="info"
                        showIcon
                    />
                    <Divider orientation="left" orientationMargin="0">
                        My Collections
                    </Divider>
                    <List
                        grid={{
                            gutter: [16,16],
                            xs: 1,
                            sm: 2,
                            md: 4,
                            lg: 3,
                            xl: 4,
                            xxl: 4,
                        }}
                        pagination={{
                            pageSize: 4
                        }}
                        dataSource={this.props.createdCollections}
                        renderItem={collection => (
                            <List.Item key={collection.id} >
                                <Link to={`/creator/created-collections/${collection.id}`}>
                                    <Card
                                        hoverable
                                        className="collection-card"
                                        cover={<img alt="example" src={collection.coverImage.image} />}
                                    >
                                        <Card.Meta title={collection.name} />
                                    </Card>
                                </Link>
                            </List.Item>
                        )}
                    />
                    <Divider orientation="left" orientationMargin="0">
                        My Modules
                    </Divider>
                    <List
                     
                        pagination={{
                            pageSize: 10
                        }}
                        dataSource={this.props.createdModules}
                        renderItem={module => (
                            <List.Item key={module.id} className="created-modules-list-item" >
                                <Link to={`/creator/created-modules/${module.id}`} style={{width: "100%"}}>
                                <Card>
                                    <div style={{ display: "flex", justifyContent: "space-between"}}>   
                                        <div>
                                            <Title level={5} style={{margin: 0}}>{module.name}</Title>

                                        
                                            <>
                                                <Text type="secondary">{`${module.primaryAuthor.firstName} ${module.primaryAuthor.lastName}`}</Text>
                                                <Text type="secondary">{module.coAuthors.map(coAuthor => <Text key={coAuthor.id}>{`, ${coAuthor.firstName} ${coAuthor.lastName}`}</Text>)}</Text>
                                            </>
                                                
                                        </div>
                                        <div>

                                        </div>
                    
                                    </div>
                                </Card>
                                </Link>
                            </List.Item>
                        )}
                    />
                </div>
    }
}

const mapStateToProps = state => {
    return {
        createdCollections: state.contentCreationReducer.userCreatedCollections,
        createdModules: state.contentCreationReducer.userCreatedModules,
        user: state.userReducer.user
    }
}

export default connect(mapStateToProps, { fetchUserCreatedCollections, fetchUserCreatedModules })(CreatorHome);